export const ImportErrorCodes = {
  INIT_CSV_GENERIC_ERROR: 'InitCsvGenericError',
  INIT_CSV_WITHOUT_DATA_ROWS: 'InitCsvWithoutDataRows',
  INIT_CSV_DATA_ROWS_LIMIT_EXCEEDED: 'InitCsvDataRowsLimitExceeded',
  INIT_UNABLE_TO_PARSE_CSV: 'InitUnableToParseCsv',
  INIT_UNABLE_TO_STORE_CSV: 'InitUnableToStoreCsv',
  UPDATE_MAPPING_EMPTY_ID: 'UpdateMappingEmptyId',
  UPDATE_MAPPING_ID_NOT_FOUND: 'UpdateMappingIdNotFound',
  DELETE_MAPPING_EMPTY_ID: 'DeleteMappingEmptyId',
  DELETE_MAPPING_ID_NOT_FOUND: 'DeleteMappingIdNotFound',
  GET_SUMMARY_EMPTY_ID: 'GetSummaryEmptyId',
};
